// The one rule for turning a typed name into a library filename.
//
// Icons and shapes are both files in a shared library, referenced by filename as
// the S3 key, and they had drifted: icons lowercased and stripped every
// non-alphanumeric ("Cisco Switch" -> "ciscoswitch"), shapes preserved case and
// substituted hyphens ("Cisco Switch" -> "Cisco-Switch"). Same dialog, same
// gesture, two answers. That is invisible until someone types the same name into
// both screens and gets two different files.
//
// The icon rule wins because it is the one already in the library: every built-in
// icon is a lowercase run of letters and digits, and a hyphenated file sitting
// among them looks like a mistake. Keys that differ only by case or punctuation
// are also a poor thing to hang an S3 object on.
//
// The extension is NOT decided here. An icon is always framed to PNG; a shape
// keeps whatever it arrived as, because an SVG that became a PNG would lose the
// thing it was chosen for. Callers append their own.
const IMAGE_EXTENSION = /\.(png|jpe?g|gif|svg|webp)$/i

export function toAssetBaseName(name: string, fallback: string): string {
    // Strip a typed extension FIRST. Without this the dot goes but the letters stay,
    // so "logo.png" becomes "logopng" — which is how a library ends up with a file
    // that reads like a typo and cannot be found by searching for "logo".
    const withoutExtension = name.trim().replace(IMAGE_EXTENSION, '')
    return withoutExtension.toLowerCase().replace(/[^a-z0-9]+/g, '') || fallback
}
